import {createContext} from 'react'

const Context = createContext({})

export const ContextProvider = Context.Provider

export const ContextConsumer = Context.Consumer



// WEBPACK FOOTER //
// ./src/Context.js